import { http } from '@/http/axios';
import type { AuthSessionMode } from '@/lib/googleSignInError';

export const sessionService = {
  setSession: (idToken: string, mode: AuthSessionMode) =>
    http.post('/auth/session', { idToken, mode }),
};
